import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  Card,
  CardBody,
  CardTitle,
  CardText,
  Badge,
  Row,
  Col,
} from "reactstrap";
import TableService from "../../../services/OrderingServices/TableService";
import BreadCrumb from "../../../Components/Common/BreadCrumb";

const DetailTable = () => {
  const { id } = useParams();
  const [tableData, setTableData] = useState(null);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true);
    const fetchTableDetail = async () => {
      try {
        const response = await TableService.detail(id); // replace with your endpoint
        setTableData(response);
      } catch (error) {
        console.error("Failed to fetch section details", error);
      } finally {
        setLoading(true);
      }
    };

    fetchTableDetail();
  }, [id]);

  const breadcrumbItems = [{ title: "Back To List ", link: "/table" }];

  return (
    <div className="page-content">
      <div class="container-fluid">
        <BreadCrumb
          pageTitle="Table"
          title="Table Detail"
          breadcrumbItems={breadcrumbItems}
        />
      </div>
      <div className="d-flex justify-content-center align-content-center align-items-center">
        <Card className="shadow-sm border-0 rounded-4 col-8">
          <CardBody>
            <Row className="mb-3">
              <Col md={6}>
                <CardTitle tag="h5" className="fw-bold text-primary">
                  Table Name: {tableData?.tableName || ""}
                </CardTitle>
              </Col>
              <Col md={6} className="text-md-end">
                <Badge
                  color={
                    tableData?.tableStatus === "Available"
                      ? "success"
                      : "danger"
                  }
                  pill
                >
                  {tableData?.tableStatus}
                </Badge>
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md={6}>
                <CardText>
                  <strong>Capacity:</strong> {tableData?.capacity}
                </CardText>
              </Col>
              <Col md={6}>
                <CardText>
                  <strong>Available:</strong>{" "}
                  <Badge
                    color={tableData?.isAvailable ? "success" : "secondary"}
                  >
                    {tableData?.isAvailable ? "Yes" : "No"}
                  </Badge>
                </CardText>
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md={6}>
                <CardText>
                  <strong>Description:</strong> {tableData?.description}
                </CardText>
              </Col>
              <Col md={6}>
                <CardText>
                  <strong>Section:</strong>{" "}
                  <span className="text-muted">{tableData?.section?.name}</span>
                </CardText>
              </Col>
            </Row>

            <Row>
              <Col>
                <h6>Section Description:</h6>{" "}
                <span className="text-muted">
                  {" "}
                  {tableData?.section?.description}
                </span>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </div>
    </div>
  );
};

export default DetailTable;
